import * as Yup from 'yup';

export const messageFeedbackValidationSchema = () =>
    Yup.object().shape({
        details: Yup.string().required('Setting up your feedback is required'),
    });
